import { Link } from 'react-router-dom';

/**
 * A list of things you open, one per row: a title, one line about it, and a quiet note on the right
 * (such as when it last changed). Each row is a link to the thing.
 */
const RowList = ({ items, label }) => {
  return (
    <ul className="comp-row-list" aria-label={label}>
      {items.map((item) => (
        <li key={item.id}>
          <Link className="comp-row-list__row" to={item.to}>
            <span className="comp-row-list__text">
              <span className="comp-row-list__title">{item.title}</span>
              {item.description && <span className="comp-row-list__description">{item.description}</span>}
            </span>
            {item.note && <span className="comp-row-list__note">{item.note}</span>}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default RowList;
